// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }



// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "instant",
//     });
//   }, [pathname]);

//   return null;
// }




// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export default function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     // Check if we are on the contact page
//     if (pathname === '/contact') {
//       // Use a small timeout to ensure the DOM is ready before scrolling
//       setTimeout(() => {
//         const element = document.getElementById('contact-start');
//         if (element) {
//           // Scroll directly to the element
//           element.scrollIntoView({ behavior: 'instant', block: 'start' });
          
//           // Alternatively, using window.scrollTo for more control:
//           // window.scrollTo({ top: element.offsetTop, behavior: 'instant' });
//         }
//       }, 0); 
//     } else {
//       // Normal behavior for all other pages (scroll to top)
//       window.scrollTo({
//         top: 0,
//         left: 0,
//         behavior: "instant",
//       });
//     }
//   }, [pathname]);

//   return null;
// }




import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/contact') {
      // SCROLL TO 150px DOWN
      window.scrollTo({
        top: 100, // Change this number to adjust how far down it starts
        left: 0,
        behavior: "instant",
      });
    } else {
      // Normal behavior for other pages
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  }, [pathname]);

  return null;
}
